import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app/bookmark",
  "use": "app/bookmark-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"app/bookmark\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.25.25h17.5v23.461l-8.717-8.034L3.25 23.7V.25zm1.5 1.5v18.549l7.288-6.658 7.212 6.648V1.75H4.75z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol